<template>
  <div class="content">
    <div class="row">
      <div class="col col-md-12">
        <admin-stats-users-rating />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    AdminStatsUsersRating: () => import('@/components/admin/stats/rating.vue')
  },
};
</script>
